import React, {useState} from 'react';
import {Grid2, Stack, Tab, Typography} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import TabList from "@mui/lab/TabList";
import PDF_file from '../../assets/raport.pdf';

export const  AboutUs = () => {
    const [tab, setTab] = useState('0');

    const handleTabChange = (event, newValue) => {
        if(tab === newValue) return;
        setTab(`${newValue}`);
    };


    return <Stack height="100%" width="100%" paddingBottom="50px">
        <TabContext value={tab}>
            <Stack direction="row"
                   alignItems="center"
                   justifyContent="center"
                   width="100%"
                   sx={{ borderBottom: 1, paddingX: 1, marginTop: -1, borderColor: 'divider' }}>
                <TabList variant="scrollable" value={tab} onChange={handleTabChange} aria-label="Tabs">
                    <Tab value={'0'} label="Ogólne" />
                    <Tab value={'1'} label="Korzyści" />
                    <Tab value={'2'} label="Przebieg" />
                    <Tab value={'3'} label="Raport z realizacji projektu" onClick={() => {
                        const link = document.createElement('a');
                        link.href = PDF_file;
                        link.download = 'raport_z_realizacji_projektu.pdf';
                        link.click();
                        setTab(tab);
                    }} />
                </TabList>
            </Stack>
            <TabPanel value={'0'}>
                <Grid2 textAlign="justify" size={{ xs: 12, md: 6 }} justifyContent="center" alignItems="center">
                    <Typography fontStyle="italic" fontWeight="bold" variant="h6">
                        Obserwuj życie ptaków i owadów w ramach projektu Citizen Science!
                    </Typography>
                    <br />
                    <Typography>
                        Przed nami kolejna wyjątkowa inicjatywa realizowana metodą Citizen Science w ramach obchodów Europejskiego Miasta Nauki Katowice 2024! Projekt skupi się na wizualnej obserwacji ptaków w budkach lęgowych przy wykorzystaniu algorytmu głębokiego uczenia, a także zakładaniu hoteli dla owadów czy apartamentów dla trzmieli.
                    </Typography>
                    <br/>
                    <Typography>
                        Inicjatywa ma charakter interdyscyplinarny i łączy wiedzę z różnych dziedzin nauki – inżynieryjno-technicznych, społecznych, ścisłych oraz przyrodniczych. W ramach projektu zostaną zainstalowane budki oraz domki lęgowe dla ptaków w wyznaczonych miejscach naszego regionu. To właśnie stamtąd, poprzez użycie nowoczesnych kamer i ogniw zasilanych energią słoneczną, będzie możliwa ich uważna obserwacja.
                        Dzięki wykorzystaniu algorytmu głębokiego uczenia (deep learning) będziemy mogli wykrywać i analizować odgłosy ptaków oraz poznawać ich zwyczaje. Dowiemy się również, jakie sygnały wysyłają poszczególne gatunki i w jaki sposób pomaga im to we wzajemnej komunikacji.
                    </Typography>
                    <br/>
                    <Typography>
                        W ramach projektu zespół badawczy założy także hotele dla owadów oraz apartamenty dla trzmieli. Zarówno wewnątrz, jak i na zewnątrz powstałych w ten sposób obiektów zostaną założone kamery, które umożliwią prowadzenie systematycznej obserwacji tych zwierząt.
                        Założeniem inicjatywy jest również promowanie zrównoważonego rozwoju oraz Europejskiego Zielonego Ładu.
                    </Typography>
                    <br/>
                    <Typography>
                        Projekt rozpoczął się 10 września 2024 roku, a podsumowanie działań prowadzonych w jego zakresie przewidziane jest na wrzesień 2025 roku.
                    </Typography>
                    <br/>
                    <Typography>
                        Koordynatorami projektu są:
                        <br/>
                        • dr Henryk A. Kretek (Katedra Stosowanych Nauk Społecznych na Wydziale Organizacji i Zarządzania, Politechnika Śląska),
                        <br/>
                        • dr Michał Staniszewski (adiunkt, Katedra Grafiki Komputerowej, Wizji i Systemów Cyfrowych, Wydział Automatyki, Elektroniki i Informatyki, Politechnika Śląska).
                        <br/>
                        <br/>
                        Współpraca – QSystems.pro sp. z o.o.
                        <br />
                        • Kamil Antos (student na kierunku informatyka praktyczna, Wydział Matematyki Stosowanej, Politechnika Śląska)
                        <br />
                        • inż. Mateusz Cebula (student studiów magisterskich na kierunku Informatyka, specjalizacja Interaktywna Grafika Trójwymiarowa, Wydział Automatyki, Elektroniki i Informatyki, Politechnika Śląska)
                        <br />
                        • inż. Aleksander Kempski (student studiów magisterskich na kierunku Macrofaculty, specjalizacja Data Science, Wydział Automatyki, Elektroniki i Informatyki, Politechnika Śląska)
                        <br />
                        <br />
                        Projekt realizowany jest ramach programu Citizen Science realizowanego w ramach obchodów Europejskiego Miasta Nauki Katowice 2024. Działanie dofinansowane ze środków Województwa Śląskiego – Współorganizatora Europejskiego Miasta Nauki Katowice 2024.
                    </Typography>
                </Grid2>
            </TabPanel>
            <TabPanel value={'1'}>
                <Grid2 textAlign="justify" size={{ xs: 12, md: 6 }} justifyContent="center" alignItems="center">
                    <Typography fontStyle="italic" fontWeight="bold" variant="h6">
                        Korzyści dla uczestników
                    </Typography>
                    <br/>
                    <Typography>
                        Wszyscy biorący aktywny udział w projekcie będą mogli dowiedzieć się wielu interesujących faktów na temat życia i zwyczajów obserwowanych zwierząt oraz uzyskać rzetelną wiedzę z zakresu ekologii i ochrony środowiska. Ponadto projekt stwarza przestrzeń do wymiany wiedzy pomiędzy młodszymi i starszymi pokoleniami. Współpraca uczestników
                    </Typography>
                    <br/>
                    <Typography>
                        pochodzących z różnych grup wiekowych jest cennym doświadczeniem, które – ucząc wrażliwości na otoczenie – staje się źródłem nowej perspektywy patrzenia na świat.
                        Co więcej, dzięki przewidzianym szkoleniom uczestnicy będą mogli nabyć umiejętności obserwacji i analizy uzyskanych wyników badań, a także nauczyć się posługiwać „Głęboką siecią neuronową” (Deep Neural Network) w wykrywaniu, rozpoznawaniu, zliczaniu ilościowym oraz przetwarzaniu danych.
                    </Typography>
                </Grid2>
            </TabPanel>
            <TabPanel value={'2'}>
                <Grid2 textAlign="justify" size={{ xs: 12, md: 6 }} justifyContent="center" alignItems="center">
                    <Typography fontStyle="italic" fontWeight="bold" variant="h6">
                        Przebieg projektu
                    </Typography>
                    <br/>
                    <Typography fontWeight="bold">Etap 1 (10 września – 15 października 2024 r.)</Typography>
                    <br />
                    <Typography marginLeft="20px">
                        W ramach pierwszej części projektu przygotowano koncepcję budki lęgowej wraz ze sposobem montażu kamery, która umożliwi obserwowanie ptaków z wewnątrz. Przedstawiono również propozycję instalacji tych obiektów w środowisku testowym. Specjaliści opracowali ponadto algorytmy głębokiego uczenia, które pomogą w analizie sygnałów i dźwięków pochodzących od ptaków. Etap zakończył się sukcesem – wszystkie zadania zostały przygotowane do realizacji w terenie!
                    </Typography>
                    <br/>
                    <Typography fontWeight="bold">
                        Etapy 2 oraz 3 (start – 22 listopad 2024 r.)
                    </Typography>
                    <br/>
                    <Typography marginLeft="20px">
                        Oficjalne rozpoczęcie projektu nastąpi 22. listopada br. w Domu Kultury w Kuźni Raciborskiej. Inauguracja odbędzie się przy udziale uczniów, nauczycieli, a także burmistrza oraz innych przedstawicieli samorządu miasta.
                        Podczas spotkania przeprowadzone zostaną szkolenia, które będą obejmować metody wizji komputerowej i sztucznej inteligencji w procesie wychwytywania oraz oceny sygnałów pochodzących od ptaków. Następnie weźmiemy udział w warsztatach, w których prowadzący przybliżą działanie algorytmu głębokiego uczenia oraz zaprezentują pracę kamery w zbudowanej budce lęgowej.
                        Wszyscy uczestnicy będą mogli uczestniczyć w prelekcjach przygotowanych przez doświadczonych badaczy – prawdziwych ekspertów w swoich dziedzinach! Dendrolog dr Jan Duda przedstawi prezentację dot. obserwacji zachowań ptaków, Józef Banaś wraz z Marcinem Absalonem poprowadzą wykład pt. „Lokalni opiekunowie projektu”, a Przedstawiciel Nadleśnictwa Rudy Raciborskiej Tomasz Szczęsny opowie o tym, jak poszczególne pory roku wpływają na zachowania ptaków.
                    </Typography>
                </Grid2>
            </TabPanel>
        </TabContext>
    </Stack>
}